import { types } from "mobx-state-tree"
const Group = types.model(
    {
        id: types.identifier,
        name: types.string
    }
);
const PrivateNote = types.model(
    {
        title: types.optional(types.string, ""),
        aboutPerson: types.optional(types.string, ""),
        aboutGroupMember: types.optional(types.boolean, false),
        body: types.string
    }
);
const Person = types.model(
    {
        firstName: types.optional(types.string, ""),
        lastName: types.optional(types.string, ""),
        email: types.optional(types.string, ""),
        isGroupMember: types.optional(types.boolean, false),
        relation: types.optional(types.string, "")                
    }
);
const UserSetting = types.model({
    theme: types.optional(types.string, "default")
});

const defaultSetting = {theme: "default"};

const User = types.model({
    _id: types.identifier,
    name: types.optional(types.string, ""),
    email: types.optional(types.string, ""),
    role: types.string,
    family: types.optional(types.string, ""),
    notes: types.optional(types.array(types.string), []),
    privateNotes: types.optional(types.array(PrivateNote), []),
    nonUserPeople: types.optional(types.array(Person), []),
    imageLink: types.optional(types.string, ""),
    settings: types.optional(UserSetting, defaultSetting),
    birthMonth: types.optional(types.number, 0),
    birthDay: types.optional(types.number, 0),
    profileImage: types.optional(types.string, "img/default-user.png"),
    isWelcomeMessageDismissed: types.optional(types.boolean, true),
    groups: types.optional(types.array(Group), []),
    childOptionsVisible: types.optional(types.boolean, false),
    kids: types.optional(types.array(types.string), []),
    isKidsAccount: types.optional(types.boolean, false),
    parentAccount: types.optional(types.string, ""),
    listRank: types.map(types.optional(types.array(types.string), []))
    
});

export default User;